var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`size-${_vm.size}`},[_c('img',{staticClass:"img-fluid",class:{ blur: !_vm.canViewPost(_vm.creatorPost) },attrs:{"src":_vm.src,"loading":"lazy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }